import { of, Observable } from 'rxjs';
import { Directive, forwardRef } from '@angular/core';
import { NG_ASYNC_VALIDATORS, AbstractControl, AsyncValidator, ValidationErrors, AsyncValidatorFn, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LanguagesService } from '../services/languages.service';
import { ValidationService } from '../services/validation.services';
import { Validazioni } from '../interfaces/utilities';

@Directive({
    selector: '[onlyLatinAllowed]',
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => LatinCharsetAsyncValidatorDirective), 
            multi: true
        },
    ]
})

export class LatinCharsetAsyncValidatorDirective implements AsyncValidator {

    constructor(
        private languagesService: LanguagesService,
        private validationServices: ValidationService) {

    }

    validate(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
        let result: any = null;
        let listaValidazioni: Validazioni[] = this.validationServices.validatorsList.value;

        if (listaValidazioni == null) {
            this.validationServices.getValidationsList()
                .subscribe((resultValidazioni) => {
                    listaValidazioni = resultValidazioni.esito == 0 ? resultValidazioni.validazioni : null;
                });
        }

        let intersection: Validazioni = listaValidazioni.find(x => x.etichetta == "caratteri_latini");

        if (intersection !== null && intersection.validazione !== null) {
            if (intersection.validazione.includes("reg:")) {

                let regex = new RegExp(
                    intersection.validazione.substring(4, intersection.validazione.length)
                );

                if (regex.test(control.value)) {
                    result = {
                        onlyLatinAllowed: this.languagesService.errors.get("15")
                    };
                }
                else
                    result = null;
            }
        }

        return new Promise<AsyncValidatorFn>((resolve, reject) => { resolve(result); });
    }
}